import { useDisclosure } from '@chakra-ui/hooks'
import { Center, Flex, Text } from '@chakra-ui/layout'
import { TableContainer } from '@chakra-ui/table'
import { useState, useMemo, memo, useEffect } from 'react'
import { useMarkup } from '../../contexts/MarkupProvider'
import { ModalItem } from '../Modal/ModalItem'
import { Trow } from './Trow'
import { Image } from '@chakra-ui/react'
import RowTable from '../RowTable'
import { CSVLink } from 'react-csv'
import { Button } from '@chakra-ui/button'

const imgLoading = '../../../../images/loading-blue.gif'

const Produtos = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [data, setData] = useState({})
  const [counter, setCounter] = useState(0)

  const { data: dataFilter, loading: allLoading } = useMarkup()

  useEffect(() => {
    setCounter(dataFilter?.length)
  }, [dataFilter])

  function openModal(item) {
    setData(item)
    onOpen()
  }

  const dataMarkup = useMemo(() => {
    return dataFilter?.map((item) => {
      const { produtos } = item

      const summary = produtos?.reduce(
        (acc, item) => {
          const { custo_total } = item

          const custoTotal = parseFloat(custo_total) || 0

          return {
            ...acc,
            custoTotal: acc.custoTotal + custoTotal,
          }
        },
        {
          custoTotal: 0,
        }
      )

      const precoBaseTotal = produtos?.reduce((acc, curr) => {
        const { preco_base, quantidade_negociada } = curr

        const precoBase = parseFloat(preco_base) || 0
        const quantidadeNegociada = parseFloat(quantidade_negociada) || 0

        return acc + precoBase * quantidadeNegociada
      }, 0)

      const markup = (summary.custoTotal / precoBaseTotal) * 100

      return {
        ...item,
        markup,
      }
    })
  }, [dataFilter])

  function firstLetterUpper(text) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
  }

  const valorVenda = dataFilter?.map((item) => {
    return item.produtos?.reduce((acc, curr) => {
      const { preco_base, quantidade_negociada } = curr

      const precoBase = parseFloat(preco_base) || 0
      const quantidadeNegociada = parseFloat(quantidade_negociada) || 0

      return acc + precoBase * quantidadeNegociada
    }, 0)
  })

  const lucroBrutoMenosTotalBase = dataFilter?.map((item) => {
    return item.produtos?.reduce((acc, curr) => {
      const { preco_base, quantidade_negociada, lucro_bruto } = curr

      const precoBase = parseFloat(preco_base) || 0
      const quantidadeNegociada = parseFloat(quantidade_negociada) || 0
      const lucroBruto = parseFloat(lucro_bruto) || 0

      return acc + precoBase * quantidadeNegociada - lucroBruto
    }, 0)
  })

  const dataCSV = []
  for (let i = 0; i < dataFilter.length; i++) {
    const item = dataFilter[i]
    const produtos = item.produtos

    if (produtos.length > 0) {
      // Se o cliente tiver produtos, adicionar apenas uma linha para o cliente com as informações repetidas
      const clienteRow = {
        DtAlter: item.Dtalter,
        Numinno: item.Numinno,
        Cliente: item.razao_social,
        'Valor nota': Number(
          Number(item.Valor_Venda) * Number(item.Quantidade)
        ).toFixed(2),
        Codprod: item.CodProd,
        Produto: item.descricao_produto,
        IdProdCor: '',
        Quantidade: '',
        'Preço base': '',
        'Valor unit': '',
        'Valor total venda': '',
        'Preço total base': '',
        'Custo total': '',
        'Lucro bruto': '',
        Porcentagem: item.Porcentagem,
        'Juros de pagamento atrasado': Number(item.juros_pagamento_atrasado)
          .toFixed(2)
          .replace('.', ','),
        'Lucro sobre condição de pagamento': Number(
          item.lucro_condicao_pagamento
        )
          .toFixed(2)
          .replace('.', ','),
        'Lucro sobre frete': Number(item.lucro_sobre_frete)
          .toFixed(2)
          .replace('.', ','),
        'Sobra innovation': Number(item.sobra_innovation)
          .toFixed(2)
          .replace('.', ','),
        'ICMS ST': Number(item.icms_st).toFixed(2).replace('.', ','),
        'Custo total (Balanco)': lucroBrutoMenosTotalBase[i]
          .toFixed(2)
          .replace('.', ','),
        'Valor total base': valorVenda[i].toFixed(2).replace('.', ','),
        'Frete (Destacado nota)': Number(item.destacado_nota)
          .toFixed(2)
          .replace('.', ','),
        'Lucro bruto (Balanco)': Number(item.balanco_lucro)
          .toFixed(2)
          .replace('.', ','),
        'CUSTO PRODUTO': Number(item.Custo_Produto)
          .toFixed(2)
          .replace('.', ','),
        'CUSTO IMPRESSÃO': Number(item.Custo_impressao)
          .toFixed(2)
          .replace('.', ','),
        'VLR UNIT CAIXA': Number(item.Vlr_Unit_Caixa)
          .toFixed(2)
          .replace('.', ','),
        'QTDE POR CAIXA': Number(item.Qtde_PorCaixa)
          .toFixed(2)
          .replace('.', ','),
        'CUSTO TOTAL CAIXA': Number(item.CustoTotalCaixa)
          .toFixed(2)
          .replace('.', ','),
        'CUS FIX COM VEND': Number(item.CusFixComVend)
          .toFixed(2)
          .replace('.', ','),
        'PER CUS FIX IMPOSTOS': Number(item.PercCusFixImpostos)
          .toFixed(2)
          .replace('.', ','),
        'PERC CUSFIX ADC2RODRIGO': Number(item.PercCusFixAdic2Rodrigo)
          .toFixed(2)
          .replace('.', ','),
        'PERC CUS FIX ADIC 1LOJA': Number(item.PercCusFixAdic1Loja)
          .toFixed(2)
          .replace('.', ','),
        'CUS FIX ADIC 1LOJA': Number(item.CusFixAdic1Loja)
          .toFixed(2)
          .replace('.', ','),
        'PERC CUS FIX ADIC3 SEGURANCA': Number(item.PercCusFixAdic3Seguranca)
          .toFixed(2)
          .replace('.', ','),
        'CUSTOS FIXOS PERCENTUAL': Number(item.CustosFixosPercentual)
          .toFixed(2)
          .replace('.', ','),
        'VLR CUSTOS FIXOS PERCENTUAL': Number(item.VlrCustosFixosPercentual)
          .toFixed(2)
          .replace('.', ','),
        'OUTROS CUSTOS': Number(item.OutrosCustos).toFixed(2).replace('.', ','),
        'CUS FIX BOLETO': Number(item.CusFixBoleto)
          .toFixed(2)
          .replace('.', ','),
        'CUS FIX FRETE COMPRA': Number(item.CusFixFreteCompra)
          .toFixed(2)
          .replace('.', ','),
        MARKUP: Number(item.Markup).toFixed(2).replace('.', ','),
        'VLR CUSTO TOTAL': Number(item.VlrCustoTal)
          .toFixed(2)
          .replace('.', ','),
        'COD IMP': Number(item.CodImp).toFixed(2).replace('.', ','),
        BATIDAS: Number(item.Batidas).toFixed(2).replace('.', ','),
        'PRAZO ENTREGA': Number(item.PrazoEntrega).toFixed(2).replace('.', ','),
        'PERC COM': Number(item.PercCom).toFixed(2).replace('.', ','),
        NUNOTA: Number(item.Nunota).toFixed(2).replace('.', ','),
        SEQUENCIA: Number(item.Sequencia).toFixed(2).replace('.', ','),
        'QTDE CAIXAS UTIL': Number(item.QtdeCaixaSutil)
          .toFixed(2)
          .replace('.', ','),
        'QTDE. PEÇA': Number(item.QtdPeca).toFixed(2).replace('.', ','),
        'CUSTO CORTE': Number(item.CustoCorte).toFixed(2).replace('.', ','),
        'ITE HORA MAQUINA': Number(item.IteHoraMaquina)
          .toFixed(2)
          .replace('.', ','),
        'ITE TEMPO CORTE UNIT': Number(item.IteTempoCorteUnit)
          .toFixed(2)
          .replace('.', ','),
      }

      dataCSV.push(clienteRow)

      // Adicionar uma linha para cada produto do cliente
      for (let j = 0; j < produtos.length; j++) {
        const produto = produtos[j]

        const produtoRow = {
          DtAlter: '',
          Numinno: '',
          Cliente: '',
          'Valor nota': '',
          Codprod: produto.CodProd,
          Produto: produto.descricao_produto,
          IdProdCor: produto.cor,
          Quantidade: produto.quantidade_negociada.replace('.', ','),
          'Preço base': parseFloat(produto.preco_base)
            .toFixed(2)
            .replace('.', ','),
          'Valor venda': parseFloat(produto.valor_unit)
            .toFixed(2)
            .replace('.', ','),
          'Valor unit': parseFloat(produto.valor_unit)
            .toFixed(2)
            .replace('.', ','),
          'Valor total venda': Number(
            parseFloat(produto.valor_unit) *
              parseInt(produto.quantidade_negociada)
          )
            .toFixed(2)
            .replace('.', ','),
          'Preço total base': Number(
            parseFloat(produto.preco_base) * produto.quantidade_negociada
          )
            .toFixed(2)
            .replace('.', ','),
          'Custo total': Number(produto.custo_total)
            .toFixed(2)
            .replace('.', ','),
          'Lucro bruto': Number(produto.lucro_bruto)
            .toFixed(2)
            .replace('.', ','),
          Porcentagem: '',
          'CUSTO PRODUTO': '',
          'CUSTO IMPRESSÃO': '',
          'VLR UNIT CAIXA': '',
          'QTDE POR CAIXA': '',
          'CUSTO TOTAL CAIXA': '',
          'CUS FIX COM VEND': '',
          'PER CUS FIX IMPOSTOS': '',
          'PERC CUSFIX ADC2RODRIGO': '',
          'PERC CUS FIX ADIC 1LOJA': '',
          'CUS FIX ADIC 1LOJA': '',
          'PERC CUS FIX ADIC3 SEGURANCA': '',
          'CUSTOS FIXOS PERCENTUAL': '',
          'VLR CUSTOS FIXOS PERCENTUAL': '',
          'OUTROS CUSTOS': '',
          'CUS FIX BOLETO': '',
          'CUS FIX FRETE COMPRA': '',
          MARKUP: '',
          'VLR CUSTO TOTAL': '',
          'COD IMP': '',
          BATIDAS: '',
          'PRAZO ENTREGA': '',
          'PERC COM': '',
          NUNOTA: '',
          SEQUENCIA: '',
          'QTDE CAIXAS UTIL': '',
          'QTDE. PEÇA': '',
          'CUSTO CORTE': '',
          'ITE HORA MAQUINA': '',
          'ITE TEMPO CORTE UNIT': '',
        }

        dataCSV.push(produtoRow)
      }

      const separatorRowTop = {
        DtAlter: '---',
        Numinno: '---',
        Cliente: '---',
        'Valor nota': '---',
        Codprod: '---',
        Produto: '---',
        IdProdCor: '---',
        Quantidade: '---',
        'Preço base': '---',
        'Valor unit': '---',
        'Valor total venda': '---',
        'Preço total base': '---',
        'Custo total': '---',
        'Lucro bruto': '---',
        Porcentagem: '---',
        'Juros de pagamento atrasado': '---',
        'Lucro sobre condição de pagamento': '---',
        'Lucro sobre frete': '---',
        'Sobra innovation': '---',
        'ICMS ST': '---',
        'Custo total (Balanco)': '---',
        'Valor total base': '---',
        'Frete (Destacado nota)': '---',
        'Lucro bruto (Balanco)': '---',
      }

      dataCSV.push(separatorRowTop)
    } else {
      // Se o cliente não tiver produtos, adicionar apenas uma linha para o cliente com todas as informações vazias
      const clienteRow = {
        DtAlter: item.Dtalter,
        Numinno: item.Numinno,
        Cliente: item.razao_social,
        'Valor nota': item['Valor nota'],
        Codprod: '',
        Produto: '',
        IdProdCor: '',
        Quantidade: '',
        'Preço base': '',
        'Valor unit': '',
        'Valor total venda': '',
        'Preço total base': '',
        'Custo total': '',
        'Lucro bruto': '',
        Porcentagem: item.Porcentagem,
        'Juros de pagamento atrasado': '',
        'Lucro sobre condição de pagamento': '',
        'Lucro sobre frete': '',
        'Sobra innovation': '',
        'ICMS ST': '',
        'Custo total (Balanco)': '',
        'Valor total base': '',
        'Frete (Destacado nota)': '',
        'Lucro bruto (Balanco)': '',
      }

      dataCSV.push(clienteRow)
    }
  }

  const exportToCSV = () => {
    const headers = [
      'DtAlter',
      'Numinno',
      'Cliente',
      'Valor nota',
      'Codprod',
      'Produto',
      'IdProdCor',
      'Quantidade',
      'Preço base',
      'Valor venda',
      'Valor total venda',
      'Preço total base',
      'Custo total',
      'Lucro bruto',
      'Porcentagem',
      'Juros de pagamento atrasado',
      'Lucro sobre condição de pagamento',
      'Lucro sobre frete',
      'Sobra innovation',
      'ICMS ST',
      'Custo total (Balanco)',
      'Valor total base',
      'Frete (Destacado nota)',
      'Lucro bruto (Balanco)',
      'CUSTO PRODUTO',
      'CUSTO IMPRESSÃO',
      'VLR UNIT CAIXA',
      'QTDE POR CAIXA',
      'CUSTO TOTAL CAIXA',
      'CUS FIX COM VEND',
      'PER CUS FIX IMPOSTOS',
      'PERC CUSFIX ADC2RODRIGO',
      'PERC CUS FIX ADIC 1LOJA',
      'CUS FIX ADIC 1LOJA',
      'PERC CUS FIX ADIC3 SEGURANCA',
      'CUSTOS FIXOS PERCENTUAL',
      'VLR CUSTOS FIXOS PERCENTUAL',
      'OUTROS CUSTOS',
      'CUS FIX BOLETO',
      'CUS FIX FRETE COMPRA',
      'MARKUP',
      'VLR CUSTO TOTAL',
      'COD IMP',
      'BATIDAS',
      'PRAZO ENTREGA',
      'PERC COM',
      'NUNOTA',
      'SEQUENCIA',
      'QTDE CAIXAS UTIL',
      'QTDE. PEÇA',
      'CUSTO CORTE',
      'ITE HORA MAQUINA',
      'ITE TEMPO CORTE UNIT',
    ]

    const csvData = {
      data: dataCSV,
      headers: headers,

      separator: ';',
      quote: false,
      filename: `Relatório de Pedidos - ${new Date().toLocaleDateString()}`,
    }

    return csvData
  }

  return (
    <>
      <Text fontSize="1.2rem" fontWeight="bold" mb={4}>
        {counter} Pedidos
      </Text>

      <Flex w="100%" justifyContent="space-between">
        <ModalItem
          isOpen={isOpen}
          onClose={onClose}
          firstLetterUpper={firstLetterUpper}
          data={data}
        />
        <Flex>
          <Button colorScheme="blue" mr={2} as={CSVLink} {...exportToCSV()}>
            {/* <CSVLink {...exportToCSV()}>Exportar</CSVLink> */}
            Exportar
          </Button>
        </Flex>
      </Flex>

      <TableContainer
        maxH="calc(100vh - 15rem)"
        overflowY="auto"
        overflowX="auto"
        sx={{
          '&::-webkit-scrollbar': {
            width: '0.5rem',
          },
          '&::-webkit-scrollbar-track': {
            width: '12px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#1A8AB6',
            borderRadius: '24px',
          },
        }}
      >
        <Flex flex={1} flexDir="column" alignItems="flex-start">
          <Flex
            alignItems="flex-start"
            gap={'.1rem'}
            position="sticky"
            top="0"
            zIndex="1"
          >
            <Trow value="Dtalter" isHead />
            <Trow value="Numinno" isHead />
            <Trow value="Cliente" isHead width="12.5rem" />
            <Trow value="Valor Back" isHead />
            <Trow value="Valor nota" isHead />
            <Trow value="CodProd" isHead />
            <Trow value="Produto" isHead width="12.5rem" />
            <Trow value="IdProdCor" isHead width="130px" />
            <Trow value="Quantidade" isHead />
            <Trow value="Preço base" isHead />
            <Trow value="Valor venda" isHead />
            <Trow value="Valor total venda" width="7.5rem" isHead />
            <Trow value="Preço total base" width="7.5rem" isHead />
            <Trow value="Custo total" isHead />
            <Trow value="Lucro bruto" isHead />
            <Trow value="Porcentagem" isHead width="7rem" />
          </Flex>
          {!allLoading && dataFilter?.length === 0 && (
            <Center flex={1} w="100%" mt="2rem">
              <Text
                color="gray.500"
                fontSize="1.5rem"
                fontWeight="bold"
                textTransform="uppercase"
                letterSpacing=".6px"
              >
                Nenhum resultado encontrado
              </Text>
            </Center>
          )}

          {allLoading && (
            <Flex
              flexDir="column"
              alignItems="center"
              justifyContent="center"
              flex={1}
              w="100%"
              mt="2rem"
            >
              <Image src={imgLoading} alt="loading" />
            </Flex>
          )}

          {!allLoading && (
            <Flex
              flex={1}
              flexDirection="column"
              gap={6}
              alignItems="flex-start"
            >
              {/* {dataFilter?.map((item, index) => {
                return (
                  <RowTable item={item} index={index} openModal={openModal} />
                )
              })} */}
              {dataMarkup?.map((item, index) => {
                return (
                  <RowTable
                    item={item}
                    key={index}
                    index={index}
                    openModal={openModal}
                  />
                )
              })}
            </Flex>
          )}
        </Flex>
      </TableContainer>
    </>
  )
}

export default memo(Produtos)
